// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__wwnN+","modal":"modal_modal__9ZtRS","header":"modal_header__Pfb4A","closeButton":"modal_closeButton__AW2aO","modalBody":"modal_modalBody__Hr4pw"};